import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getarrivals } from "../../store/home/homeAction";
import Card from "../../component/Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import Loader from "../../component/Loader";

const Services = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lan = useSelector((state) => state.LanSlicer.language);

  return (
    <section className="flat-services">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="section-title wow fadeInDown">
              <h4 className="section-subtitle">What i do</h4>
              <h2 className="section-45px-montserrat margin-top-15">
                Service & Solutions
              </h2>
            </div>
            <div
              className="themesflat-spacer clearfix"
              data-desktop="47"
              data-mobile="60"
              data-smobile="60"
              style={{ height: "60px" }}
            ></div>
          </div>
          <div className="col-md-4">
            <div className="services-box">
              <div className="wraper-effect"></div>
              <span className="icon-services icon-development1 font-size-icon"></span>
              <div className="services-content">
                <a
                  href="service-single.html"
                  className="section-22px-montserrat"
                >
                  Product Design
                </a>
                <p className="services-desc">
                  Fusce consectetur erat id enim elementum tincidunt. Vestibulum
                  accumsan elementum leo, et viverra justo ultricies ac.
                </p>
                <a href="service-single.html" className="read-more"></a>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="services-box active">
              <div className="wraper-effect active"></div>
              <span className="icon-services icon-webpage1 font-size-icon active"></span>
              <div className="services-content">
                <a
                  href="service-single.html"
                  className="section-22px-montserrat"
                >
                  UX / UI Design
                </a>
                <p className="services-desc">
                  Fusce consectetur erat id enim elementum tincidunt. Vestibulum
                  accumsan elementum leo, et viverra justo ultricies ac.
                </p>
                <a href="service-single.html" className="read-more"></a>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="services-box">
              <div className="wraper-effect"></div>
              <span className="icon-services icon-branding1 font-size-icon"></span>
              <div className="services-content">
                <a
                  href="service-single.html"
                  className="section-22px-montserrat"
                >
                  Branding Design
                </a>
                <p className="services-desc">
                  Fusce consectetur erat id enim elementum tincidunt. Vestibulum
                  accumsan elementum leo, et viverra justo ultricies ac.
                </p>
                <a href="service-single.html" className="read-more"></a>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="services-box">
              <div className="wraper-effect"></div>
              <span className="icon-services icon-web-programming1 font-size-icon"></span>
              <div className="services-content">
                <a
                  href="service-single.html"
                  className="section-22px-montserrat"
                >
                  Web Development
                </a>
                <p className="services-desc">
                  Fusce consectetur erat id enim elementum tincidunt. Vestibulum
                  accumsan elementum leo, et viverra justo ultricies ac.
                </p>
                <a href="service-single.html" className="read-more"></a>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="services-box">
              <div className="wraper-effect"></div>
              <span className="icon-services icon-development1 font-size-icon"></span>
              <div className="services-content">
                <a
                  href="service-single.html"
                  className="section-22px-montserrat"
                >
                  Software Development
                </a>
                <p className="services-desc">
                  Fusce consectetur erat id enim elementum tincidunt. Vestibulum
                  accumsan elementum leo, et viverra justo ultricies ac.
                </p>
                <a href="service-single.html" className="read-more"></a>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="services-box">
              <div className="wraper-effect"></div>
              <span className="icon-services icon-advertising1 font-size-icon"></span>
              <div className="services-content">
                <a
                  href="service-single.html"
                  className="section-22px-montserrat"
                >
                  Digital Marketing
                </a>
                <p className="services-desc">
                  Fusce consectetur erat id enim elementum tincidunt. Vestibulum
                  accumsan elementum leo, et viverra justo ultricies ac.
                </p>
                <a href="service-single.html" className="read-more"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
